import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store, Version, VersionService } from '../..';

@Component({
  selector: 'version-management-dialog',
  templateUrl: './version-management-dialog.component.html',
  styleUrls: ['./version-management-dialog.component.scss']
})
export class VersionManagementDialogComponent {
  version?: Version;
  versionId: string = '';
  fromVersionId: string = '';
  previousVersionId: string = '';
  eventId: string = '';
  selectedTabIndex = 0;
  selectedStores: Store[] = [];

  constructor(
    private versionService: VersionService<Version>,
    public dialogRef: MatDialogRef<VersionManagementDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { versionId: string, eventId: string, fromVersionId?: string, stores?: Store[] }
  ) { }

  action: string = 'cancelled';

  ngOnInit() {
    this.versionService.eventId = this.data.eventId;
    this.versionId = this.data.versionId;
    this.previousVersionId = this.data.versionId;
    this.fromVersionId = this.data.fromVersionId ?? '';
    this.selectedStores = this.data.stores ?? [];
    this.eventId = this.data.eventId;
  }

  close(): void {
    this.dialogRef.close(this.action);
  }

  switchToTab(index: number): void {
    this.selectedTabIndex = index;
  }

  onMoveToNewVersion(event: any) {
    if (event) {
      this.switchToTab(0);
      this.fromVersionId = this.versionId;
      this.versionId = '0';
      this.selectedStores = event.stores;
    }
  }

  onVersionDetails(version: Version) {
    this.version = version;
    this.versionId = version.Id;
  }

  updateActionType(type: string = 'cancelled') {
    this.action = type;
  }

  closeDialog(type: string = 'cancelled') {
    this.action = type;
    if (this.previousVersionId != '0' && this.fromVersionId && this.selectedStores.length) {
      this.versionId = this.previousVersionId;
      this.fromVersionId = '';
      this.selectedStores = [];
      this.selectedTabIndex = 1;
    } else {
      this.close();
    }
  }

}
